import * as IDS from './canister_ids.json';
import { isLocalEnv, isTestNetEnv } from './env';

const ENV = isLocalEnv() ? 'local' : isTestNetEnv() ? 'staging' : 'ic';

export const IC_RESOLVER_ID = IDS.ic_resolver[ENV];
export const ICP_RESOLVER_ID = IDS.icp_resolver[ENV];

